import { layout as modelStatementLine } from "views/AccountStatement2/StatementLine";
import { layout as modelInvoice } from "views/Invoice2/Invoice";
import { layout as modelParty } from "./modelParty";
import { layout as layoutTaxes } from "./layoutUpdateTaxes";
import imgDespegar from "assets/apps/despegar.png";
import imgBooking from "assets/apps/booking.png";
import imgExpedia from "assets/apps/expedia.png";
import imgHouse from "assets/apps/house.png";
import WizardAddRoom from "../WizardAddRoom";
import WizardPayment from "../WizardPayment";
import WizardBill from "../WizardBill";
import WizardUpdateTaxes from "../WizardUpdateTaxes";
import { layout as modelFolio } from "apps/HotelFolio/models/folio";
import { layout as layoutUpdateTaxes } from "./layoutUpdateTaxes";
import dates from "tools/dates";
import { PlusCircleIcon, ReceiptIcon } from "components/Icons";
import { getStorage } from "store/local";
import proxy from "api/proxy";

const stateColors = {
  offer: "amber",
  confirmed: "lime",
  cancelled: "rose",
  finished: "sky",
  no_show: "gray",
};

const MEDIA = [
  { id: "phone", name: "phone" },
  { id: "email", name: "email" },
  { id: "chat", name: "chat" },
  { id: "walking", name: "walking" },
  { id: "web", name: "web" },
  { id: "channel_manager", name: "channel_manager" },
  { id: "ota", name: "ota" },
];

const RESPONSIBLE = [
  { id: "holder", name: "Titular" },
  { id: "holder_guest", name: "Titular / Huesped" },
  { id: "guest", name: "Huesped" },
];

const STATE = [
  { id: "draft", name: "Draft" },
  { id: "confirmed", name: "Confirmed" },
  { id: "cancelled", name: "Cancelled" },
  { id: "finished", name: "Finished" },
  { id: "no_show", name: "No Show" },
];

const CHANNEL_PAYMENT_METHOD = [
  { id: "at_destination", name: "at_destination" },
  { id: "ota_collect", name: "ota_collect" },
];

const TYPE_COMPLIMENTARY = [
  { id: "in_house", name: "in_house" },
  { id: "courtesy", name: "courtesy" },
];

const iconOTA = {
  house: imgHouse,
  booking: imgBooking,
  despegar: imgDespegar,
  expedia: imgExpedia,
};

function getOTAInvisible(_, record) {
  const res = record.channel?.kind === "ota";
  return res;
}

function getOTARequired(record, x) {
  // console.log("prueba ", record, x);
  const res = record.channel?.kind === "ota";
  return res;
}

function getImageChannel(record) {
  let image = imgHouse;
  if (record["channel."]?.code) {
    const code = record["channel."].code;
    image = iconOTA[code];
  }
  return image;
}

function getComplimentaryRequired(record) {
  return record?.complimentary;
}

const visibleConfirm = (_, record) => {
  let res = false;
  if (
    record &&
    ["offer", "no_show"].includes(record.state) &&
    record.lines &&
    record.lines.size > 0
  ) {
    res = true;
  }
  return res;
};

function visibleBill(_, record) {
  if (
    record &&
    record.state === "confirmed" &&
    record.lines &&
    record.lines.size > 0
  ) {
    return true;
  }
  return false;
}

function onChangeChannel(record) {
  if (record.channel) {
    record.rate_plan = record.channel.rate_plan;
    record.price_list = null;
  }
  return record;
}

function invisibleAddPayment(nameField, record) {
  let res = true;
  if (record?.number && ["offer", "confirmed"].includes(record?.state.id)) {
    res = false;
  }
  // const res = record?.number;
  // console.log("invisibleAddPayment...", nameField, record, res);
  return res;
}

function searchPriceList(_, record) {
  let res = null;
  if (record?.channel?.rate_plan) {
    console.log("Record >> ", record);
    res = [["id", "in", record.channel["rate_plan."].price_lists]];
  }
  return res;
}

// function searchMealPlan(value, record) {
//   let res = [];
//   if (record.price_list && record.price_list?.meal_plan) {
//     res = [["id", "=", record?.price_list?.meal_plan]];
//   }
//   return res;
// }

async function withChangePriceList(record, store) {
  if (record.price_list?.meal_plan) {
    const { data: mealPlan } = await proxy.search(
      "hotel.meal_plan",
      [["id", "=", record?.price_list?.meal_plan]],
      ["name"],
    );
    if (mealPlan.length > 0) {
      record.meal_plan = { id: mealPlan[0].id, name: mealPlan[0].name };
      store.meal_plan = mealPlan[0].id;
    }
  }
}

const getFilters = () => {
  return {
    offer: [
      ["state", "=", "offer"],
      // ["booking_date", ">=", yesterday],
      // ["shop", "=", session.shop],
    ],
    confirmed: [
      ["state", "=", "confirmed"],
      // ["booking_date", ">=", yesterday],
      // ["shop", "=", session.shop],
    ],
  };
};

function visibleCancel(_, record) {
  if (record?.lines && record.lines.size > 0) {
    return true;
  }
  return false;
}

function visibleNoShow(_, record) {
  if (record && record.state === "offer") {
    return true;
  }
  return false;
}

async function sendEmail(name, record) {
  if (record.id < 0) return;
  let template;
  if (name === "booking") {
    template = "booking_email";
  } else {
    // template = "send_email_statement";
    return;
  }

  const { data } = proxy.methodInstance({
    model: "hotel.booking",
    method: "send_email",
    instance: record.id,
    args: [template],
  });
  return data;
}

function layout() {
  const args = { showFolioNumber: true };
  const ctxView = {
    model: "hotel.booking",
    display: "board",
    form_action: ["edit", "add"], // options: ['save', 'delete']
    table_action: ["edit", "add", "date-card"], // options: ['open', 'delete', 'edit', 'add', "info"]
    activeSearch: true,
    filters: getFilters,
    orderBy: [["number", "DESC"]],
    limit: 50,
    selectable: null, // Options for table rows: null, multi, one
    // pagination: [],
    reports: [
      {
        name: "hotel.booking",
        label: "hotel.booking.report",
        description: "hotel.booking.report",
        send_print: true,
        sendEmail: (record) => sendEmail("booking", record),
      },
      {
        name: "hotel.booking_statement",
        label: "hotel.booking_statement.report",
        description: "hotel.booking_statement.report",
        send_print: true,
        // send_email: (record) => sendEmail("statement", record),
      },
    ],
    actions: [
      {
        name: "hotel.booking.update_taxes",
        label: "hotel.booking.update_taxes",
        Component: WizardUpdateTaxes,
        description: "hotel.booking.update_taxes",
        layout: layoutUpdateTaxes(),
      },
      // {
      //   name: "hotel.intent_payment",
      //   description: "Detalle de Reserva Confirmada",
      // },
    ],
    tags: {
      state: stateColors,
    },
    sources: {
      image: iconOTA,
    },
    fields: {
      number: {
        type: "char",
        readOnly: true,
        searchable: true,
      },
      contact: {
        type: "char",
        searchable: true,
        required: true,
      },
      channel: {
        type: "many2one",
        model: "hotel.channel",
        searchable: true,
        getImage: getImageChannel,
        withChange: onChangeChannel,
        attrs: ["code", "rate_plan", "kind", "rate_plan.price_lists"],
        dependents: ["ota_booking_code"],
        required: true,
      },
      agent: {
        type: "many2one",
        model: "commission.agent",
        searchable: true,
        // attrs: ["code"],
      },
      ota_booking_code: {
        type: "char",
        searchable: true,
        getRequired: getOTARequired,
        invisible: getOTAInvisible,
      },
      bill_to: {
        type: "selection",
        options: RESPONSIBLE,
        default: RESPONSIBLE[0],
        // translate: true,
        required: true,
      },
      party: {
        type: "many2one",
        model: "party.party",
        searchable: true,
        ctxView: modelParty(),
        // attrs: ["account_receivable"],
      },
      lines: {
        type: "one2many",
        model: "hotel.folio",
        layout: modelFolio(args),
      },
      environment: {
        type: "many2one",
        model: "sale.shop",
        default: () => getStorage("hotelShop"),
        readOnly: true,
      },
      company: {
        type: "many2one",
        model: "company.rec_name",
      },
      booking_date: {
        type: "datetime",
        readOnly: true,
        default: () => dates.getNow(),
      },
      total_amount: {
        type: "numeric",
        readOnly: true,
      },
      tax_amount: {
        type: "numeric",
        readOnly: true,
      },
      total_advances: {
        type: "numeric",
        readOnly: true,
      },
      pending_to_pay: {
        type: "numeric",
        readOnly: true,
      },
      media: {
        type: "selection",
        options: MEDIA,
        translate: true,
      },
      group: {
        type: "boolean",
        translate: true,
      },
      corporative: {
        type: "boolean",
        translate: true,
      },
      meal_plan: {
        type: "many2one",
        model: "hotel.meal_plan",
        // withChange: withChangePriceList,
        required: true,
      },
      state: {
        type: "selection",
        translate: true,
        default: "offer",
        readOnly: true,
        tags: stateColors,
        options: STATE,
      },
      link_web_checkin: {
        type: "char",
        link: true,
        readOnly: true,
      },
      complimentary: {
        type: "boolean",
        translate: true,
        dependents: ["type_complimentary"],
      },
      pax: {
        type: "integer",
        readOnly: true,
        // default: ,
      },
      notes: {
        type: "text",
      },
      channel_payment_method: {
        type: "selection",
        translate: true,
        options: CHANNEL_PAYMENT_METHOD,
      },
      payment_term: {
        type: "many2one",
        model: "account.invoice.payment_term",
        default: () => getStorage("hotelConfig")["payment_term."],
      },
      payments: {
        type: "one2many",
        model: "account.statement.line",
        color: "black",
        layout: modelStatementLine(),
      },
      invoices: {
        type: "one2many",
        model: "account.invoice",
        color: "black",
        layout: modelInvoice(),
      },
      // notifications: {
      //   type: "one2many",
      //   model: "account.invoice",
      //   color: "black",
      //   layout: modelInvoice(),
      // },
      price_list: {
        type: "many2one",
        recSearch: searchPriceList,
        withChange: withChangePriceList,
        model: "product.price_list",
        required: true,
        attrs: ["meal_plan"],
      },
      rate_plan: {
        type: "many2one",
        model: "hotel.rate_plan",
        // required: true,
        attrs: ["name", "price_lists"],
      },
      lead_origin: {
        type: "many2one",
        recSearch: () => [],
        model: "crm.lead_origin",
      },
      confirm: {
        type: "button",
        button_method: "confirm",
        visible: visibleConfirm,
        onSuccessMsg: "Confirmacion exitosa!",
        color: "blue",
        style: "w-full",
      },
      cancel: {
        type: "button",
        button_method: "cancel",
        visible: visibleCancel,
        onSuccessMsg: "Cancelado exitosa!",
        color: "rose",
        style: "w-full",
      },
      block: {
        type: "button",
        button_method: "block",
        visible: visibleCancel,
        onSuccessMsg: "Bloqueo exitosa!",
        color: "black",
        style: "w-full",
      },
      no_show: {
        type: "button",
        button_method: "no_show",
        visible: visibleNoShow,
        onSuccessMsg: "No mostrado exitosa!",
        color: "slate",
        style: "w-full",
      },
      add_rooms: {
        type: "button_wizard",
        Component: WizardAddRoom,
        color: "sky",
        style: "h-full",
        icon: <PlusCircleIcon className="h-5 w-5 fill-current" />,
        invisible: invisibleAddPayment,
        resetWizard: false,
      },
      add_payment: {
        type: "button_wizard",
        Component: WizardPayment,
        color: "lime",
        icon: <PlusCircleIcon className="h-5 w-5 fill-current" />,
        invisible: invisibleAddPayment,
      },
      taxes_exception: {
        type: "button_check",
        button_method: "apply_taxes_exception",
        readOnly: {
          state: ["offer", "finished", "cancelled"],
        },
      },
      bill: {
        type: "button_wizard",
        Component: WizardBill,
        visible: visibleBill,
        color: "amber",
        // icon: "fi fi-rs-receipt",
        icon: <ReceiptIcon className="h-5 w-5 fill-current" />,
      },
      type_complimentary: {
        type: "selection",
        translate: true,
        options: TYPE_COMPLIMENTARY,
        getRequired: getComplimentaryRequired,
      },
    },
    list: [
      { name: "number", width: "7%" },
      { name: "channel", widget: "image" },
      { name: "ota_booking_code", width: "7%" },
      { name: "party", width: "15%" },
      { name: "contact", width: "10%" },
      { name: "agent", width: "15%" },
      { name: "total_amount", width: "10%" },
      { name: "group", width: "7%" },
      {
        name: "state",
        width: "10%",
        widget: "badge",
      },
    ],
    form: [
      {
        type: "panel",
        name: "panelLeft",
        width: "w-2/3",
        elements: [
          { name: "party", widget: "search" },
          {
            type: "grid",
            name: "group-1",
            elements: [{ name: "number" }, { name: "booking_date" }],
            colSpan: "col-span-1",
          },
          {
            type: "grid",
            name: "group-2",
            elements: [{ name: "contact" }, { name: "channel" }],
            colSpan: "col-span-1",
          },
          {
            type: "grid",
            name: "group-3",
            elements: [{ name: "price_list" }, { name: "meal_plan" }],
            colSpan: "col-span-1",
          },
          {
            type: "grid",
            name: "group-4",
            elements: [{ name: "bill_to" }, { name: "payment_term" }],
            colSpan: "col-span-1",
          },
          {
            type: "grid",
            name: "group-5",
            elements: [{ name: "add_rooms" }, { name: "add_payment" }],
            // elements: [{ name: "add_rooms" }],
            colSpan: "col-span-1",
          },
          // {
          //   name: "lines",
          //   widget: "cards",
          //   colSpan: "col-span-2",
          //   // height: "h-2/5",
          //   // style: "w-full",
          // },
          {
            type: "grid",
            name: "group-6",
            elements: [
              { name: "pax" },
              { name: "group" },
              { name: "corporative" },
            ],
            colSpan: "col-span-1",
          },
          {
            type: "grid",
            name: "group-9",
            elements: [
              { name: "lead_origin" },
              { name: "ota_booking_code" },
              { name: "link_web_checkin" },
            ],
            colSpan: "col-span-1",
          },
          {
            type: "grid",
            name: "group-8",
            elements: [{ name: "taxes_exception" }, { name: "environment" }],
            colSpan: "col-span-1",
          },
          {
            type: "grid",
            name: "group-7",
            elements: [
              { name: "total_amount" },
              { name: "total_advances" },
              { name: "pending_to_pay" },
            ],
            colSpan: "col-span-1",
          },

          {
            type: "grid",
            name: "group-10",
            elements: [
              { name: "complimentary" },
              { name: "type_complimentary" },
            ],
            colSpan: "col-span-1",
          },
          {
            type: "grid",
            name: "group-11",
            elements: [{ name: "agent" }, { name: "state" }],
            colSpan: "col-span-1",
          },
          { name: "notes" },
          // {
          //   type: "tabs",
          //   tabs: {
          //     advances_payments: [{ name: "payments" }],
          //     invoices: [{ name: "invoices" }],
          //     notifications: [{ name: "notifications" }],
          //   },
          //   colSpan: "col-span-1",
          // },
          {
            type: "grid",
            name: "group-12",
            elements: [
              { name: "no_show" },
              { name: "cancel" },
              { name: "confirm" },
              // { name: "block" },
              // { name: "bill" },
            ],
            style: "flex gap-x-2",
            colSpan: "col-span-1",
          },
        ],
      },
      {
        type: "panel",
        name: "panelRight",
        style: "1/3 pr-3 grid cols-3 gap-x-3",
        elements: [
          {
            type: "grid",
            name: "tabs_info",
            style: "h-fit grid cols-3 gap-x-2 mt-4",
            elements: [
              { name: "payments", widget: "button_tab" },
              { name: "invoices", widget: "button_tab" },
              // { name: "notifications", widget: "button_tab" },
            ],
          },
          {
            name: "lines",
            widget: "cards",
            colSpan: "col-span-2",
            // height: "h-2/5",
            // style: "w-full",
          },
        ],
      },
    ],
  };

  return ctxView;
}

export { layout };
